import { getOrg } from "utils/site";
import { State } from "./types";
import { initialStateFra } from "./fra";
import { initialStateGer } from "./ger";
import { initialStateSwe } from "./swe";

export const getInitialState = (): State => {
  const org = getOrg();

  switch (org) {
    case "ger":
      return initialStateGer;
    case "fra":
      return initialStateFra;
    case "swe":
      return initialStateSwe;

    default:
      throw new Error(`Could not get initial state for ${org}`);
  }
};
